/* Parwin: live "Choose your colour: <name>" label on the product page.
   Updates the colour option's selected-value span on swatch hover and selection.
   Pure delegation, no libraries. */
(function () {
  if (window.__parwinColourLabel) return;
  window.__parwinColourLabel = true;

  function spanFor(label) {
    var fs = label.closest('fieldset');
    return fs ? fs.querySelector('[data-colour-value]') : null;
  }
  function selectedName(fs) {
    var checked = fs && fs.querySelector('input[type="radio"]:checked');
    var l = checked && checked.closest('label[data-colour-name]');
    return l ? l.getAttribute('data-colour-name') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var label = e.target.closest && e.target.closest('label[data-colour-name]');
    if (!label) return;
    var span = spanFor(label);
    if (span) span.textContent = label.getAttribute('data-colour-name');
  });
  document.addEventListener('mouseout', function (e) {
    var label = e.target.closest && e.target.closest('label[data-colour-name]');
    if (!label) return;
    var fs = label.closest('fieldset');
    var span = fs && fs.querySelector('[data-colour-value]');
    if (!span) return;
    var n = selectedName(fs);
    if (n) span.textContent = n;
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var label = input.closest && input.closest('label[data-colour-name]');
    if (!label) return;
    var span = spanFor(label);
    if (span) span.textContent = label.getAttribute('data-colour-name');
  });
})();
